var React = require('react');

function WaveDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"title","key":0},"wave"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M0,95.5L0,0l1920,0v65.5c-196,36-452.1,15.7-657.5-8.5C1032.8,29.9,392.5,0,0,95.5z"}))]);
}

WaveDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1920 95.5","style":{"enableBackground":"new 0 0 1920 95.5"},"xmlSpace":"preserve"};

module.exports = WaveDown;

WaveDown.default = WaveDown;
